export const STORE_NAME = {
  auth: 'auth',
  drawer: 'drawer',
  theme: 'theme',
};
